import React  from "react";
import PanelHeader from "../PanelHeader";
import Table from "./table";
const Statistics = () => {
  return (
    <div className="content">
      <div className="panel-header bg-primary-gradient">
        <PanelHeader />
      </div>
      <div className="page-inner mt--5">
        <Table />
      </div>
    </div>
  );
};

export default Statistics;
